import React from "react";
import CloseIcon from "../CloseIcon";

interface ICloseButtonProps {
  onClick: () => void;
}

const CloseButton = (props: ICloseButtonProps) => (
  <a
    {...props}
    href="#"
    className="w-50 h-50 flex justify-center items-center absolute top-0 right-0"
  >
    <CloseIcon />
  </a>
);

export default CloseButton;
